import { useQuery } from "@tanstack/react-query";
import IntlMessage from "components/util-components/IntlMessage";
import useAuth from "hooks/useAuth";
import NumberFormat from "react-number-format";
import UserService from "services/UserService";
import { CreditCardOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function UserCredit({ compact }) {

    const { isAuth: isShop, adminstration } = useAuth(['ROLE_SHOP']);
    const { isAuth: isSalesman } = useAuth(['ROLE_SALESMAN']);
    const { isAuth: isAddCreditRequest } = useAuth(['ROLE_ADD_CREDIT_REQUEST']);
    const history = useHistory();

    // he need to be a shop or a salesman with edit_shop role and not an administrator
    const canSeeCredit = (isShop && !adminstration) || (isSalesman && !adminstration);

    const { data } = useQuery({ ...UserService.getCredit(), enabled: canSeeCredit, refetchInterval: 40000 });
    const credit = data?.data.credit || 0;
    const gradeStar = data?.data?.gradeStar;

    if (!canSeeCredit) return null;

    return (
        <div className="d-flex align-items-center">
            {!compact && <strong className="mb-0"><IntlMessage id="commen.credits" /> : &nbsp;</strong>}
            <strong className="mb-0"><NumberFormat value={credit} displayType={'text'} thousandSeparator={true} suffix=' dt' /></strong>
            <img src={`/img/grade/grade_${gradeStar}.png`} width={45} alt="credit" className="ml-2" />
            {isAddCreditRequest && <Menu mode="horizontal">
                <Menu.Item key="user-credit" onClick={() => history.push('/app/credit-request')}>
                    <CreditCardOutlined />
                </Menu.Item>
            </Menu>}
        </div>
    );
}
export default UserCredit;